export function makeWhyIntercoColumn () {
  return {
    headerName: 'Why Intercompany',
    valueGetter: function (cellParams) {
      if (cellParams.data.type === 'break') return null
      if (cellParams.data.type === 'date') return null
      if (cellParams.data.type === 'entityPair') return null

      const reasons = makeReasonsArray(cellParams.data.transaction)
      return makeReasonsOutput(reasons, 'text')
    },
    cellRenderer: function (cellParams) {
      if (!cellParams.value) return null

      const reasons = makeReasonsArray(cellParams.data.transaction)
      const output = makeReasonsOutput(reasons, 'tag')

      return output
    }
  }
}

function makeReasonsArray (transaction) {
  const array = []
  if (transaction?.is_intercompany_contact) array.push('contact')
  if (transaction?.is_intercompany_chart_of_account) array.push('chartOfAccount')
  return array
}

function makeReasonsOutput (reasons, outputProperty) {
  return reasons.map(reason => settings[reason][outputProperty]).join('')
}

const settings = {
  contact: {
    text: 'Contact',
    tag: '<span class="tag is-light is-info">Contact</span>'
  },
  chartOfAccount: {
    text: 'Chart of Account',
    tag: '<span class="tag is-light is-primary">Chart of Account</span>'
  }
}
